import { useMemo } from 'react'

import taskDetailJson from '../../demo/fixtures/task-detail.json'
import { selectOptimizations, useCampaign } from '../../demo/selectors'
import { useDemoStore } from '../../demo/store'
import { Badge, Button, Card, CardHead, Icon } from '../../ui'
import type { IconName } from '../../ui/Icon'
import { latestAdjustment } from './autopilot'
import styles from './TaskDetailPage.module.css'

export function AudienceAnalysis({ campaignId, onAdjust }: { campaignId: string; onAdjust: () => void }) {
  const optimizationState = useDemoStore((state) => state.optimizations)
  const adjustment = useMemo(() => { void optimizationState; return latestAdjustment(selectOptimizations(campaignId), ['audience']) }, [campaignId, optimizationState])
  const audience = (taskDetailJson.byProduct[useCampaign(campaignId)?.productId as keyof typeof taskDetailJson.byProduct] ?? taskDetailJson.byProduct['p-mug'])[adjustment ? 'audienceAfterAdjust' : 'audienceAnalysis']
  return (
    <Card data-scope="detail-audience-analysis">
      <CardHead title={<>{taskDetailJson.sectionTitles.audienceAnalysis}{adjustment ? <Badge tone="green" className={styles.adjustedBadge} data-scope="ap-adjusted-badge" title={`${adjustment.at} · ${adjustment.why}`}>AI 已调整</Badge> : null}</>} action={<Button variant="link" onClick={onAdjust}>{taskDetailJson.sectionActions.audienceAnalysis}</Button>} />
      <div className={styles.cardPad}>
        <div className={styles.audienceRows}>{audience.map((item, index) => <div className={`${styles.audienceRow} ${adjustment && index === 0 ? styles.audienceRowAdjusted : ''}`} key={item.tier}>
          <span className={styles.audienceIcon}><Icon name={item.icon as IconName} size={19} /></span>
          <b>{item.tier}</b><span>{item.who}{adjustment && index === 0 ? <small className={styles.audienceNarrow}>AI 本次收窄</small> : null}</span><span>{item.focus}</span>
        </div>)}</div>
      </div>
    </Card>
  )
}
